<template>
  <div class="issue-status-icons">
    <span v-for="(issue, index) in issues" v-if="index < 3">
      <img class="issue-status-icons__icon" :src="getIcon(issue.issueType)" @mouseover="currentPopover = index" @mouseleave="currentPopover = null">
      <div class="issue-status-icons__status-badge" :class="issue.status" v-if="issue.serviceProvider != null"></div>

      <transition name="fade" mode="in-out">
        <div class="popover" v-if="currentPopover == index">
          <div class="popover__status-badge" :class="issue.status"></div>
          <span class="popover__status-text">{{formatStatus(issue.status)}}</span>
        </div>
      </transition>
    </span>

    <span class="issue-status-icons__more-text font-primary--bold" v-if="(issues.length - 1) > 2"> + {{issues.length - 3}} more</span>
  </div>
</template>

<script>
  export default {
    name: 'issue-status-icons',

    props: ['issues'],

    data: function () {
      return {
        currentPopover: null
      }
    },

    created: function() {

    },

    methods: {
      formatStatus:  function(status) {
        status = status.replace(/-/g, " ");
        return status;
      },

      getIcon: function(issueType) {
        let iconMatrix = {
          smells: '/static/img/area__smell--off.svg',
          disability: '/static/img/area__accessibility--off.svg',
          lighting: '/static/img/area__light--off.svg',
          heating: '/static/img/area__heating--off.svg',
          babychanging: '/static/img/area__baby--off.svg',
          cubicles: '/static/img/area__door--off.svg',
          mirrors: '/static/img/area__mirror--off.svg',
          decor: '/static/img/area__paint--off.svg',
          wallsfloors: '/static/img/area__wall--off.svg',
          sanitary: '/static/img/area__sanitary--off.svg',
          toilet: '/static/img/area__toilet--off.svg',
          urinals: '/static/img/area__urinal--off.svg',
          airfresheners: '/static/img/area__smell--off.svg',
          handwashing: '/static/img/area__soap--off.svg',
          sink: '/static/img/area__sink--off.svg',
          papertowels: '/static/img/area__towel--off.svg',
          handdrying: '/static/img/area__drier--off.svg',
          toiletroll: '/static/img/area__paper--off.svg',
          vendingmachines: '/static/img/area__vending--off.svg',
          suggestions: '/static/img/area__suggestion--off.svg',
          customsuggestion: '/static/img/area__suggestion--off.svg'
        };

        return iconMatrix[issueType.replace(/\d+/g,'')];
      }
    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .issue-status-icons {
    white-space: nowrap;

    > span {
      display: inline-block;
      position: relative;
      vertical-align: middle;

      .issue-status-icons__icon {
        width: 4rem;
        float: left;
        margin-right: 0.75rem;
      }

      .issue-status-icons__status-badge {
        width: 1rem;
        height: 1rem;
        position: absolute;
        bottom: 0;
        right: 0.75rem;
        border-radius: 50%;
      }

      .popover {
        position: absolute;
        top: -1rem;
        right: 5rem;
        // width: 22.5rem;
        padding: 2rem;
        border: 1px solid @brand__grey2;
        border-radius: 1rem;
        background-color: #fff;
        box-shadow: 0 0 14px 3px rgba(0,0,0,0.05);
        text-align: center;
        white-space: nowrap;

        &::before, &::after {
          content: '';
          display: block;
          width: 1rem;
          height: 1rem;
          border: 1rem solid transparent;
          border-left: 1rem solid @brand__grey2;
          position: absolute;
          top: 2rem;
          right: ~"calc(-2rem)";
        }

        &::after {
          border-left: 1rem solid #fff;
          right: ~"calc(-2rem + 1px)";
        }

        .popover__status-badge {
          display: inline-block;
          width: 2rem;
          height: 2rem;
          margin-right: 1rem;
          border-radius: 50%;
          vertical-align: middle;
        }

        .popover__status-text {
          text-transform: capitalize;
        }
      }

      .unread {
        background-color: @brand__grey3;
      }

      .resolved-by-retailer {
        background-color: @brand--secondary-color;
      }

      .confirmed {
        background-color: @accent__red;
      }

      .denied {
        background-color: @brand--primary-color;
      }

      .resolution-in-progress {
        background-color: @accent__amber;
      }

      .resolution-awaiting-approval {
        background-color: @accent__violet;
      }

      .resolution-accepted {
        background-color: @accent__green;
      }

      .resolution-denied {
        background-color: @accent__blue;
      }
    }

    .issue-status-icons__more-text {
       color: @brand--primary-color;
    }
  }
</style>



// WEBPACK FOOTER //
// IssueStatusIcons.vue?e3d7d920